import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { useCart } from "@/lib/cart";
import { useLang, lp } from "@/lib/i18n";

const T = {
  fr: { add: "Ajouter au panier", added: "Ajouté au panier", view: "Voir le panier", qty: "Quantité",
        note: "Commande sans paiement en ligne : la maison confirme la disponibilité et t'adresse les modalités de règlement par e-mail." },
  en: { add: "Add to cart", added: "Added to cart", view: "View cart", qty: "Quantity",
        note: "No online payment: the house confirms availability and sends you the payment details by e-mail." },
};

// Bouton d'ajout au panier, avec sélecteur de quantité.
// `product` = { reference, label, collection, price, url }
export const AddToCart = ({ product, light = false, className = "" }) => {
  const lang = useLang();
  const t = T[lang];
  const { add } = useCart();
  const [qty, setQty] = useState(1);
  const muted = light ? "text-black/50" : "text-zinc-500";
  const border = light ? "border-black/20 text-black" : "border-zinc-700 text-zinc-200";

  const onAdd = () => {
    add(product, qty);
    toast.success(`${t.added} — ${product.label}`, {
      action: { label: t.view, onClick: () => { window.location.href = lp(lang, "/panier"); } },
    });
  };

  return (
    <div className={className} data-testid="add-to-cart">
      <div className="flex flex-wrap items-center gap-5">
        <div className={`inline-flex items-center border ${border}`} aria-label={t.qty}>
          <button type="button" onClick={() => setQty((q) => Math.max(1, q - 1))} className="w-11 h-11 text-lg" aria-label="−" data-testid="qty-minus">−</button>
          <span className="w-8 text-center tabular-nums" data-testid="qty-value">{qty}</span>
          <button type="button" onClick={() => setQty((q) => Math.min(99, q + 1))} className="w-11 h-11 text-lg" aria-label="+" data-testid="qty-plus">+</button>
        </div>
        <button type="button" onClick={onAdd} className="val-btn" data-testid="add-to-cart-btn">{t.add}</button>
        <Link to={lp(lang, "/panier")} className="val-link text-[13px] tracking-[0.2em] uppercase" data-testid="view-cart-link">{t.view}</Link>
      </div>
      <p className={`mt-5 max-w-md text-[14px] leading-[1.75] ${muted}`}>{t.note}</p>
    </div>
  );
};
